import {useState, useEffect} from "react";
import {Columns, FormContainer} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import './drivers.css'
import VerticalSpace from "../../../../palette/VerticalSpace";
import {generateUUID} from '../../../../utils/HelpFunctions';
import DriversForm from "./DriversFrom";
import {Animated} from "react-animated-css";
import VehicleForm from "./VehicleForm";


function DriversManagementForm(props) {

    const {
        trigger, setTrigger, DataStore, setVisibleForm, setVisibleGrid, dataSource, dataDriversArray,
        visibleForm, ControlStore
    } = props

    const [load, setLoad] = useState(true)
    const [storageID, setStorageID] = useState('')
    const [dataDrivers, setDataDrivers] = useState(null)

    useEffect(() => {
        const ID = generateUUID();
        setStorageID(ID)

    }, [])


    return (
        <>
            <VerticalSpace space={30}/>
            <div className="drivers-management-form" style={{width: dataDrivers ? '95%' : '75%'}}>
                <HeaderPage icon={'fas fa-car'} text={'Crear conductores y vehículos'} load={load}
                            textLoad={'Guardando....'}/>
                <FormContainer>
                    <Columns>
                        <DriversForm etVisibleForm={setVisibleForm} setTrigger={setTrigger} trigger={trigger}
                                     DataStore={DataStore} setVisibleGrid={setVisibleGrid} dataSource={dataSource}
                                     dataDriversArray={dataDriversArray} storageID={storageID}
                                     setDataDrivers={setDataDrivers} dataDrivers={dataDrivers}
                                     setVisibleForm={setVisibleForm}
                        />

                        {dataDrivers &&
                        <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                            <VehicleForm dataDrivers={dataDrivers} setTrigger={setTrigger} trigger={trigger}
                                         setVisibleGrid={setVisibleGrid} setVisibleForm={setVisibleForm}
                                         setDataDrivers={setDataDrivers} DataStore={DataStore}
                                         ControlStore={ControlStore}
                                         dataDriversArray={dataDriversArray} visibleForm={visibleForm}
                            />
                        </Animated>
                        }
                    </Columns>
                </FormContainer>
            </div>
            <VerticalSpace space={15}/>
        </>
    )
}

export default DriversManagementForm
